export default __webpack_public_path__ + "static/media/logo.b338d873.svg";